import { Form, Row, Col, Container } from 'react-bootstrap';
import { Parser } from 'html-to-react'
function Consent({
    customisation,
    consentGDPR,
    consentImage,
    setConsent,
}) {
    return (
        <Container className="custom-consent">
            {customisation.image_right &&
                <>
                    <Row>
                        <Col>
                            <h2>{customisation.title_consent_image_right}</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='d-flex align-items-center'>
                            {customisation.consent_checkbox_image_right &&
                                <Form.Check
                                    type="checkbox"
                                    name="image_right"
                                    label={Parser().parse(customisation.image_right_text)}
                                    value={true}
                                    checked={consentImage}
                                    onChange={(e) => setConsent(e, "image")}
                                />
                            }
                            {!customisation.consent_checkbox_image_right &&
                                <p dangerouslySetInnerHTML={{ __html: customisation.image_right_text }}></p>
                            }
                        </Col>
                    </Row>
                </>
            }
            { /*  Gestion du consentement RGPD */}
            {customisation.consent_gdpr &&
                <>
                    <Row className="consent-gdpr">
                        <Col>
                            <h2>{customisation.title_consent}</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            {customisation.consent_checkbox &&
                                <Form.Check
                                    type="checkbox"
                                    name="consent_gdpr"
                                    label={Parser().parse(customisation.consent_gdpr_text)}
                                    value={customisation.consent_gdpr_text}
                                    checked={consentGDPR}
                                    onChange={(e) => setConsent(e, "gdpr")}
                                    className='align-items-center grpd'
                                />
                            }

                            {!customisation.consent_checkbox &&
                                <p dangerouslySetInnerHTML={{ __html: customisation.consent_gdpr_text }}></p>
                            }

                        </Col>
                    </Row>
                </>
            }
        </Container >
    )
}

export default Consent;
